var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { createElement, forwardRef } from 'react';
import styled from 'styled-components';
import { responsiveRadiusStyle } from '../../styles';
import { useTheme } from '../../theme';
import { Box } from '../box';
import { Flex } from '../flex';
import { Icon } from '../icon';
import { Text } from '../text';
import { buttonBaseStyles, buttonColorStyles } from './styles';
var Root = styled.button(responsiveRadiusStyle, buttonBaseStyles, buttonColorStyles);
export var Button = forwardRef(function (props, ref) {
  var children = props.children,
      disabled = props.disabled,
      icon = props.icon,
      iconRight = props.iconRight,
      _props$justify = props.justify,
      justify = _props$justify === void 0 ? 'center' : _props$justify,
      _props$mode = props.mode,
      mode = _props$mode === void 0 ? 'default' : _props$mode,
      _props$padding = props.padding,
      padding = _props$padding === void 0 ? 3 : _props$padding,
      paddingX = props.paddingX,
      paddingY = props.paddingY,
      paddingTop = props.paddingTop,
      paddingBottom = props.paddingBottom,
      paddingLeft = props.paddingLeft,
      paddingRight = props.paddingRight,
      _props$radius = props.radius,
      radius = _props$radius === void 0 ? 2 : _props$radius,
      selected = props.selected,
      size = props.size,
      _props$space = props.space,
      space = _props$space === void 0 ? 3 : _props$space,
      text = props.text,
      _props$tone = props.tone,
      tone = _props$tone === void 0 ? 'default' : _props$tone,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      restProps = __rest(props, ["children", "disabled", "icon", "iconRight", "justify", "mode", "padding", "paddingX", "paddingY", "paddingTop", "paddingBottom", "paddingLeft", "paddingRight", "radius", "selected", "size", "space", "text", "tone", "type"]);

  var theme = useTheme();
  var boxProps = {
    padding: padding,
    paddingX: paddingX,
    paddingY: paddingY,
    paddingTop: paddingTop,
    paddingBottom: paddingBottom,
    paddingLeft: paddingLeft,
    paddingRight: paddingRight
  };
  return React.createElement(Root, Object.assign({
    "data-ui": "Button"
  }, restProps, {
    "data-disabled": disabled,
    "data-selected": selected ? '' : undefined,
    disabled: disabled,
    radius: radius,
    ref: ref,
    tone: tone,
    type: type,
    uiMode: mode
  }), (icon || text || iconRight) && React.createElement(Box, Object.assign({
    as: "span"
  }, boxProps), React.createElement(Flex, {
    as: "span",
    justify: justify
  }, icon && React.createElement(Text, {
    size: size
  }, typeof icon === 'function' && createElement(icon), typeof icon === 'string' && React.createElement(Icon, {
    symbol: icon
  })), text && React.createElement(Box, {
    flex: iconRight ? 1 : undefined,
    marginLeft: icon ? space : undefined,
    marginRight: iconRight ? space : undefined
  }, React.createElement(Text, {
    size: size,
    weight: theme.sanity.button.textWeight
  }, text)), iconRight && React.createElement(Text, {
    size: size
  }, typeof iconRight === 'function' && createElement(iconRight), typeof iconRight === 'string' && React.createElement(Icon, {
    symbol: iconRight
  })))), children && React.createElement("span", null, children));
});
Button.displayName = 'Button';